export default __webpack_public_path__ + "static/media/015-balloons.be6e54b5.svg";